<template>
    <div>
        <b-modal
                v-model="show"
                size="md"
                no-close-on-backdrop
                centered
                :title="canEdit==true?'Заявка на акцию':'Просмотр акции'"
                @hide="close(false)"
        >
            <b-container fluid>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Организация</label>
                        <div class="disabled-filled-option">{{item!=null?item.organization.orgName:''}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Название акции</label>
                        <div class="disabled-filled-option">{{item!=null?item.stockTitle:''}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Описание</label>
                        <div class="disabled-filled-option">{{item!=null?item.stockDescription:''}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Дата начала акции</label>
                        <div class="disabled-filled-option">{{item!=null?formatDate(item.dateStart):''}}</div>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Дата окончания акции</label>
                        <div class="disabled-filled-option">{{item!=null?formatDate(item.dateEnd):''}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Размер плитки</label>
                        <div class="disabled-filled-option">{{item!=null?(sizesStock.find(x=>x.value==item.stockSize)!=null?sizesStock.find(x=>x.value==item.stockSize).text:''):''}}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Изображение плитки акции (354 x 354)</label>
                        <div v-if="item!=null" style="width:100px">
                            <expandable-image
                                    width="150%"
                                    :src="$root.docsUrl+item.stockImage"
                            />
                        </div>

                    </b-col>
                </b-row>
                <b-row class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Изображение в детализации акции(1080 x 540)</label>
                        <div v-if="item!=null" style="width:200px">
                            <expandable-image
                                    width="150%"
                                    :src="$root.docsUrl+item.stockDetailImage"
                            />
                        </div>

                    </b-col>

                </b-row>

            </b-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">
                        <v-col v-if="canEdit" cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-red)"

                                    outlined
                                    size="sm"
                                    @click="rejectCommentModal=true"
                            >
                                Отклонить
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col v-if="canEdit" cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="accept"
                            >
                                Одобрить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="close(false)"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>

        <b-modal
                v-model="rejectCommentModal"
                size="lg"
                no-close-on-backdrop
                centered
                title="Отклонение акции"
        >
            <b-container fluid>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Комментарий</label>
                        <b-input
                               placeholder="Опишите причину отказа"
                                v-model="rejectComment"
                        />
                    </b-col>
                </b-row>

            </b-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-red)"
                                    dark
                                    size="sm"
                                    @click="reject"
                            >
                                Отклонить
                            </v-btn>
                        </v-col>

                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="rejectCommentModal=false"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>
    </div>

</template>

<script>
    export default {
        name: "DetailsStockModal",
        props:{
            show:Boolean,
            item:Object
        },
        data(){
            return {
                rejectCommentModal:false,
                rejectComment:null,
                errors: [],
                imageModel: null,
                imageDetailModel: null,
            }
        },
        computed:{
            sizesStock(){
                return this.$store.state.Stocks.sizesStock;
            },

            canEdit(){
                if (this.item==null) return false
              //если акция в статусе ожадает проверки
              if(this.item.stockStatusCode=='SS02')
                  return true
                else return false
            },

        },
        methods:{
            close(isSave){
                this.rejectCommentModal=false
                    this.rejectComment=null
                this.$emit("close", isSave)
            },


            reject(){
                let model={
                    comment:this.rejectComment,
                    stockId:this.item.id
                }
                this.$store.dispatch("Stocks/rejectStock", model).then(()=>{
                    this.$bvToast.toast("Акция успешно отклонена", {
                        variant: "success",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                    this.close(true)
                }).catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            accept(){
                this.$store.dispatch("Stocks/acceptStock", this.item.id).then(()=>{
                    this.$bvToast.toast("Акция успешно одобрена", {
                        variant: "success",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                    this.close(true)
                }).catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

        },
    }
</script>

<style scoped>

</style>